import axios from "axios";



const instance = axios.create({
  //  baseURL: "http://localhost:8081/api"
  //  baseURL: "https://mmc-api-luhvw3mzyq-uc.a.run.app/api/"
  baseURL: process.env.REACT_APP_BASE_URL
});

instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // config.headers['Content-Type'] = 'multipart/form-data'
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
export default instance;
